import { render } from "./padel-search.template.html?vue&type=template&id=3b7ccd7e&scoped=true"
import script from "./PadelSearch.vue?vue&type=script&lang=ts"
export * from "./PadelSearch.vue?vue&type=script&lang=ts"

import "./PadelSearch.vue?vue&type=style&index=0&id=3b7ccd7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b7ccd7e"

export default script